// extracted by mini-css-extract-plugin
export default {"Wrapper":"Title-module-Wrapper"};